export default "__VITE_ASSET__BLr71V7C__"